import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

@Injectable({ providedIn: 'root' })
export class MarkMoodAskedApiMutation extends ApiMutation<void, void> {
	client = 'iam';
	document = gql`
		mutation MarkMoodAsked {
			markMoodAsked
		}
	`;
	method = 'markMoodAsked';
}
